import PrivacyRoute from "../../components/routes/PrivacyRoute";
import messages from "../../i18n/messages/es.json";

export default function Page() {
  return <PrivacyRoute locale="es" messages={messages} />;
}
